module.exports = __webpack_public_path__ + "img/grit.c0421727.gif";